export const PHONE_NUMBER = '+48 123 123 123';
export const EMAIL = 'lorem@ipsum.com';

export const LIST_1 = `- Funkcjonalna architektura
- Doskonała lokalizacja i czyste powietrze
- Kameralność i komfort
- Ogrodzone zamykane domy`;

export const LIST_2 = `- Jasne, przestronne wnętrza
- Wybrukowane podjazdy oraz wydzielone miejsca postojowe
- Wygodne ogrody dla każdego segmentu
- Wysoki standard wykończenia`;

export const LIST_3 = `1. Fundamenty - ławy z betonu żwirowego, stal
2. Ściany fundamentowe - z betonu; dodatkowo ocieplone drenującymi płytami styropianowymi
3. Ściany zewnętrzne - dwuwarstwowe - z pustaków ceramicznych ocieplone warstwą styropianu gr. 15 cm; wykończenie tynkiem cienkowarstwowym na siatce z włókna szklanego
4. Ściany wewnętrzne konstrukcyjne - z pustaków ceramicznych
5. Schody wewnętrzne - żelbetonowe.
6. Stropy żelbetonowe, monolityczne
7. Ściany działowe - z cegły, pustaka ceramicznego
8. Kominy - przewody kominowe i wentylacyjne systemowe firmy SCHIEDEL
9. Konstrukcja dachu - krokwiowo-płatwiowa drewniana nasycona środkami przeciwogniowymi i zabezpieczającymi przed korozją biologiczną
10. Dach pokryty dachówką ceramiczną, rynny dachowe i spustowe z PCV, obróbki dekarskiej z blachy powlekanej
11. Stolarka okienna plastikowa i drzwiowa metalowa ognioodporna
12. Ogrodzenia stalowe kratowane`;

export const LIST_4 = `1. Ściany działowe wykończone tynkami gipsowymi, w pomieszczeniach narażonych
na większą wilgotność (łazienki) tynkami cementowymi
2. Instalacja wodna, kanalizacyjna wewnętrzna, gazowa i centralnego ogrzewania wykonana zgodnie
z projektem budowlanym;  zamontowany kocioł gazowy dwufunkcyjny
w łazienkach i grzejnikami oraz ogrzewanie podłogowe w holu i łazienkach
3. Instalacja elektryczna wykonana zgodnie z projektem budowlanym
4. Wylewki cementowe wypoziomowane ocieplone styropianem
5. Parapety wewnętrzne – odlewy z tworzywa sztucznego,
zewnętrzne - z blachy powlekanej
6. Poddasze - połać dachu docieplona wełną mineralną i wykończona płytami
gipsowo-kartonowymi, ognioodpornymi, schodki systemowe na strych
7. Podjazdy i podejścia do budynku - brukowane
8. Domofon - kompletna instalacja w bramie wejściowej do domu;
w budynkach okablowanie
9.   Okna - plastikowe pięciokomorowe trzyszybowe z mikrowentylacją
10. Drzwi wejściowe - typu antywłamaniowego klasy C
11. Bramy garażowe - segmentowe z automatycznym sterowaniem
12. Balkony i tarasy -  wylewka i metalowe balustrady;
sztachety drewniane, kostka brukowa
13. Ogrodzenie domów - wykończone metalową kratą.
14. Odprowadzenie wód opadowych do żwirowych
studzienek deszczowo-burzowych wokół domu
15. Teren ziemny wokół domu wyplantowany z posianą świeżą trawą.`;